<template>
  <v-container>
    <v-row>
      <v-col col="6">
        <v-btn color="secondary" v-if="buttonShow('create')" outlined @click="create">
          <v-icon left>mdi-newspaper-plus</v-icon>Create
        </v-btn>
        <v-btn color="secondary" v-if="buttonShow('import')" outlined @click="$refs.income.click()">
          <v-icon left>mdi-home-import-outline</v-icon>Import
        </v-btn>
        <v-btn outlined color="secondary" @click="refresh()">
          <v-icon>mdi-autorenew</v-icon>Refresh
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3" lg="3" sm="6">
        <total-number
          :total="totalAmount"
          :title="'Total payment'"
          :subtitle="'Total payment received'"
        ></total-number>
      </v-col>
      <v-col cols="12" md="3" lg="3" sm="6">
        <total-number :total="totalThisWeek" :title="'Total this week'" :subtitle="thisWeek"></total-number>
      </v-col>
      <v-col cols="12" md="3" lg="3" sm="6">
        <total-number :total="totalThisMonth" :title="'Total this month'" :subtitle="thisMonth"></total-number>
      </v-col>
      <v-col cols="12" md="3" lg="3" sm="6">
        <total-number :total="totalDiscount" :title="'Total discount'" :subtitle="'Total discount'"></total-number>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4" lg="4" sm="6">
        <v-text-field
          label="Search"
          v-on:keyup.enter="filter()"
          hint="Press 'Enter' to search"
          v-model="searchKeyWords"
          hide-detail="auto"
          placeholder="Supplier/Customer, Reference No., Voucher No."
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
    <!-- <line-chart :chart-data="chartData" :options="options" /> -->
    <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="pagging"
      :server-items-length="totalItems"
      class="elevation-1 mt-5"
    >
      <template v-slot:[`item.debit`]="{ item }">${{ item.debit | thousandSeprator }}</template>
      <template v-slot:[`item.credit`]="{ item }">${{ item.credit | thousandSeprator }}</template>
      <template v-slot:[`item.actions`]="{ item }" v-if="buttonShow('actions')">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="secondary" small dense v-bind="attrs" v-on="on">Actions</v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(action, index) in menus"
              :key="index"
              @click="doAction(action.value, item)"
            >
              <v-list-item-title>{{ action.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    <!-- Create payout records -->
    <create-payment-record
      :value="createPayoutModal"
      :mode="mode"
      :data="data"
      v-model="createPayoutModal"
      @created="payoutCreated"
    />
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
    <input
      type="file"
      accept=".xlsx"
      id="income"
      ref="income"
      style="display: none"
      @change="perpareImport"
    />
  </v-container>
</template>
<script>
// import campaignAPIs from '../Campaign/campaignAPIs';
// import FinanceDataTable from './FinanceDataTable';
import Loading from 'vue-loading-overlay';
import LineChart from '../../charts/LineChart';
import CreatePaymentRecord from './CreatePaymentRecordModal';
import TotalNumber from './TotalNumber';
import paymentAPIs from './paymentAPIs';
import config from '@/config';
export default {
  components: {
    LineChart,
    TotalNumber,
    Loading,
    CreatePaymentRecord
  },
  data() {
    return {
      mode: 'new',
      data: null,
      thisWeek: null,
      thisMonth: null,
      searchKeyWords: null,
      selectDateModal: false,
      createPayoutModal: false,
      totalThisMonth: 0,
      totalThisWeek: 0,
      totalDiscount: 0,
      totalAmount: 0,
      totalItems: 0,
      isLoading: false,
      menus: [
        { title: 'Edit', value: 'edit' },
        { title: 'Delete', value: 'delete' }
      ],
      dates: [],
      chartData: {
        labels: [],
        datasets: []
      },
      options: {
        fill: false,
        responsive: true,
        maintainAspectRatio: false
      },
      pagging: {
        page: 1,
        itemsPerPage: 10
      },
      items: [],
      headers: [
        {
          text: 'Date',
          value: 'date',
          sortable: false
        },
        {
          text: 'Supplier/Customer',
          value: 'customerName',
          sortable: false
        },
        {
          text: 'Reference No.',
          value: 'referenceNo',
          sortable: false
        },
        {
          text: 'I/O Quote No.',
          value: 'IOQuoteNo',
          sortable: false
        },
        {
          text: 'Voucher No.',
          value: 'voucherNo',
          sortable: false
        },
        {
          text: 'Description',
          value: 'description',
          sortable: false
        },
        {
          text: 'Debit',
          value: 'debit',
          sortable: false
        },
        {
          text: 'Credit',
          value: 'credit',
          sortable: false
        },
        {
          text: 'Remarks',
          value: 'remarks',
          sortable: false
        },
        {
          text: 'Actions',
          value: 'actions'
        }
      ],
      campaigns: [],
      totalCampaigns: 0
    };
  },
  watch: {
    pagging(newValue) {
      console.log(newValue);
      this.findAll(newValue);
    }
  },
  computed: {
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    dateRangeText() {
      return this.dates.join(' ~ ');
    }
  },
  methods: {
    buttonShow(type) {
      const buttonPermission = config['userPermissions']['financial'][type];

      if (Array.isArray(buttonPermission)) {
        return buttonPermission.includes(this.currentUserRole);
      } else if (typeof buttonPermission === 'object') {
        return buttonPermission.userRoles.includes(this.currentUserRole) && buttonPermission.campaignStatus.includes(this.campaignStatus);
      }

      return false;
    },
    async perpareImport(e) {
      const uploadedFiles = Object.keys(e.target.files).map(i => e.target.files[i]);
      if (!uploadedFiles || uploadedFiles.length === 0) {
        this.$swal({
          type: 'info',
          text: 'No file uploaded'
        });
        return;
      }
      const file = uploadedFiles[0];
      let formData = new FormData();
      formData.append('income', file);
      const result = await paymentAPIs.importPaymentRecords(formData);
      const total = result.totalRecords || 0;
      const created = result.created || 0;
      this.$swal({
        type: 'success',
        title: 'Import successfully',
        text: `${created}/${total} records were uploaded!`
      });
      this.refresh();
    },
    create() {
      this.createPayoutModal = true;
      this.mode = 'new';
      this.data = null;
    },
    edit(item) {
      this.createPayoutModal = true;
      this.mode = 'edit';
      this.data = Object.assign({}, item);
    },
    doAction(action, item) {
      switch (action) {
        case 'edit':
          this.edit(item);
          break;
        case 'delete':
          this.delete(item);
          break;
        default:
          return;
      }
    },
    async delete(item) {
      try {
        if (!item) return;
        const id = item.id;
        const result = await this.$swal({
          icon: 'warning',
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          showCancelButton: true,
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        });
        if (result.value) {
          await paymentAPIs.deletePaymentRecords(id);
          this.refresh();
          this.$swal({
            icon: 'success',
            text: 'Deleted!'
          });
        }
      } catch (error) {
        const message = error.message || 'Cannot delete this item';
        this.$swal({
          icon: 'error',
          text: message
        });
      }
    },
    filter() {
      const keywords = this.searchKeyWords;
      if (!keywords) return;
      this.findAll({ q: keywords });
    },
    refresh() {
      this.findAll();
      this.getSummary();
    },
    async getSummary() {
      try {
        this.isLoading = true;
        const resp = await paymentAPIs.getPaymentOrReceiptSummary();
        if (resp.success) {
          const data = resp.data;
          this.totalThisMonth = data.totalThisMonth;
          this.totalThisWeek = data.totalThisWeek;
          this.totalAmount = data.totalIncome;
          this.totalDiscount = data.totalDiscount;
          const week = data.week || {};
          this.thisWeek = `${week.startTime} to ${week.endTime}`;
          this.thisMonth = data.month;
          this.totalItems = data.totalItems;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async findAll(filter = {}) {
      try {
        this.isLoading = true;
        const resp = await paymentAPIs.getPaymentRecords(filter);
        if (resp.success) {
          const data = resp.data;
          if (!data.incomes) {
            return;
          }
          this.items = data.incomes.map(item => {
            item.customerName = item.customer ? item.customer.name : '';
            return item;
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    payoutCreated() {
      this.refresh();
    }
  },
  mounted() {
    this.getSummary();
  }
};
</script>



// WEBPACK FOOTER //
// MoneyIn.vue?6d738f0a